const titleErrorForDaysToDeliverySum =
	"Total percentage for Days to Delivery fields must not exceed 100%";

export const underwritingDaysToDeliverySum = ({
	value,
	fields,
	daysToDeliveryNames,
	daysToDeliveryData,
}: {
	value: number | string;
	fields: { [key: string]: string };
	daysToDeliveryNames: string[];
	daysToDeliveryData: { [key: string]: any };
}) => {
	const currentName = Object.keys(fields)[0];

	const fieldsArray = daysToDeliveryNames
		?.filter(fieldName => fieldName !== currentName)
		?.map(fieldName => Number(daysToDeliveryData[fieldName]));

	fieldsArray.push(Number(value || 0));

	const sum = fieldsArray.reduce((acc, val) => acc + val, 0);
	if (sum > 100) {
		return titleErrorForDaysToDeliverySum;
	}
};

export const riskExposureCalculatorDaysToDeliverySum = ({
	value,
	fields,
	daysToDeliveryNames,
}: {
	value: number | string;
	fields: { [key: string]: string };
	daysToDeliveryNames: string[];
}) => {
	let sum = 0;

	for (const key of daysToDeliveryNames) {
		const value = parseFloat(fields[key]);
		if (!isNaN(value)) {
			sum += value;
		}

		if (sum > 100) {
			return titleErrorForDaysToDeliverySum;
		}
	}
};
